import React from 'react';
import Header from './HomeContent/Header';
import SectionOne from './HomeContent/SectionOne';
import SectionNew from './HomeContent/SectionNew';
import SectionAbout from './HomeContent/SectionAbout';
import Footer from './HomeContent/Footer';
import SectionTry from './HomeContent/SectionTry';
import SectionExplain from './HomeContent/SectionExplain';

import SectionOneOne from './HomeContent/SectionOneOne';

const Home = () => {

  return (
    <div >
      <Header />
      <SectionOne />
      <SectionOneOne />
      <SectionAbout />
      <SectionExplain />
      <SectionNew />
      <SectionTry />
      <Footer />
    </div>
  );
}

export default Home;